<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="fornecedores" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters :filters="filters" v-model="filtrosAtivos"></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('fornecedor.criar_fornecedores')"
            depressed
            color="accent"
            :to="{ name: 'fornecedor-formulario' }"
          >
            <v-icon class="mdi mdi-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.tipo="{ item }">
        <span class="caption">
          {{
          item.tipo === "F" ? "Pessoa física" : "Pessoa júridica"
          }}
        </span>
        <br />
        {{ strDocumento(item) }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon>
          {{
          item.ativo
          ? "mdi-checkbox-marked-outline"
          : "mdi-checkbox-blank-outline"
          }}
        </v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y v-model="menu[item.id]">
          <template v-slot:activator="{ on }">
            <v-btn icon small text v-on="on" @click="$set(menu, item.id, true)">
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card width="150">
            <v-row justify="space-around" class="pa-3">
              <botao-contatos
                :params="{
                  id_entidade: item.id,
                  tipo_entidade: 'fornecedores',
                  titulo: 'Contatos de ' + item.nome,
                }"
              />
              <lista-enderecos-dialog
                tipo="fornecedores"
                :id-entidade="item.id"
                :title="`Endereços de ${item.nome}`"
                @open="$set(menu, item.id, false)"
              />
              <lista-documentos-dialog
                :title="`Documentos de ${item.nome}`"
                :id-proprietario="item.id"
                url-base="fornecedores"
                @open="$set(menu, item.id, false)"
              />
            </v-row>
          </v-card>
        </v-menu>
        <v-btn
          v-if="perms.includes('fornecedor.criar_fornecedores')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('fornecedor.excluir_fornecedores')"
          titulo="Deletar fornecedor"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
    <contato-dialog />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
import ListaEnderecosDialog from "../components/entidades/ListaEnderecosDialog";
import ContatoDialog from "../components/contatos/ContatoDialog";
import BotaoContatos from "../components/contatos/BotaoContatos";
export default {
  components: {
    DatatableFilters,
    DialogConfirm,
    ListaEnderecosDialog,
    ListaDocumentosDialog,
    ContatoDialog,
    BotaoContatos
  },
  data() {
    return {
      headers: [
        { text: "#", value: "id" },
        { text: "Tipo", value: "tipo" },
        { text: "Nome / Nome fantasia", value: "nome" },
        { text: "Razão social", value: "razao_social" },
        { text: "Ativo", value: "ativo", sortable: false, align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      filters: [
        {
          name: "nome",
          label: "Nome / Nome fantasia",
          type: "text",
          defaultValue: ""
        },
        {
          name: "razao_social",
          label: "Razão social",
          type: "text",
          defaultValue: ""
        },
        {
          name: "ativo",
          label: "Ativo",
          type: "switch",
          options: {
            trueValue: "Sim",
            falseValue: "Não"
          },
          defaultValue: true
        }
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.fornecedores") || `{"ativo" : true}`
      ),
      loading: true,
      menu: []
    };
  },
  computed: mapState({
    fornecedores: state => state.fornecedor.fornecedores,
    perms: state => state.usuarios.usuarioAtivo.permissoes
  }),
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("fornecedor/deletar", id);
      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "fornecedor-formulario-editar",
        params: { id }
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("fornecedor/listar", {
          filtros: this.filtrosAtivos,
          carregarVendedor: true
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de fornecedores"
        });
      }
      this.loading = false;
    },
    strDocumento(fornecedor) {
      const doc = fornecedor.cpf_cnpj;
      if (fornecedor.tipo === "F") {
        return `${doc.substr(0, 3)}.${doc.substr(3, 3)}.${doc.substr(
          6,
          3
        )}-${doc.substr(-2)}`;
      } else {
        return `${doc.substr(0, 2)}.${doc.substr(2, 3)}.${doc.substr(
          5,
          3
        )}/${doc.substr(8, 4)}-${doc.substr(-2)}`;
      }
    }
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.fornecedores", JSON.stringify(val));
      this.listar();
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de fornecedores"
    });
    this.listar();
  }
};
</script>
